import React from "react";

export interface BPMRow {
  from: number;
  pricePerGram: number;
}

export interface DieselPremium {
  dieselPremiumFrom: number;
  dieselPremiumPricePerGram: number;
}
export interface Settings {
  brands: string[];
  importCostsFixed: number;
  importPercentageStaffel: Array<{
    from: number;
    to: number;
    percentage: number;
  }>;
  bpmRows: {
    [year: string]: {
      bpmGasoline: BPMRow[];
      bpmDiesel: BPMRow[];
      bpmHybrid: BPMRow[];
    };
  };
  dieselPremium: {
    [year: string]: DieselPremium;
  };
  lumpPercentageTable: Array<{
    minAge: number;
    maxAge: number;
    percentage: number;
    monthlyAdditionPercentage: number;
  }>;
}

const SettingsContext = React.createContext({});
export default SettingsContext;
